export class User {
    public name: string = "";
    public crmid: string = "";
    public jwt: string = "";
    public ticketSso: string = "";
    public profile: any = {};
    public expiration: any = {};

    constructor(json: any = null) {
        if (json) {
            if (json["name"]) this.name = json["name"];
            if (json["crmid"]) this.crmid = json["crmid"];
            if (json["profile"]) this.crmid = json["profile"];
            if (json["jwt"]) this.jwt = json["jwt"];
            if (json["ticketSso"]) this.ticketSso = json["ticketSso"];
            if (json["expiration"]) this.expiration = json["expiration"];
        }
    }
}